var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDoller(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.6665 1.33594V14.6693",
    stroke: "white",
    strokeWidth: 1.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9998 3.33594H6.99984C6.381 3.33594 5.78751 3.58177 5.34992 4.01936C4.91234 4.45694 4.6665 5.05043 4.6665 5.66927C4.6665 6.28811 4.91234 6.8816 5.34992 7.31919C5.78751 7.75677 6.381 8.0026 6.99984 8.0026H10.3332C10.952 8.0026 11.5455 8.24844 11.9831 8.68602C12.4207 9.12361 12.6665 9.7171 12.6665 10.3359C12.6665 10.9548 12.4207 11.5483 11.9831 11.9859C11.5455 12.4234 10.952 12.6693 10.3332 12.6693H4.6665",
    stroke: "white",
    strokeWidth: 1.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoller);
export default __webpack_public_path__ + "static/media/doller.c9c5ff53099665f31e14d660814ee540.svg";
export { ForwardRef as ReactComponent };